import React, {useContext, useRef, useState} from 'react';
import { SlideMenu } from 'primereact/slidemenu';
import { Button } from 'primereact/button';
import "primeicons/primeicons.css"; //icons
import "primereact/resources/themes/mdc-light-deeppurple/theme.css"
import {Dialog} from "primereact/dialog";
import {Toolbar} from "primereact/toolbar";
import Login from "./Login";
import Registration from "./Registration";
import {TabMenu} from "primereact/tabmenu";
import {AuthContext} from "../App";
import {Menu} from "primereact/menu";

// TODO
// Maybe change dialog to Overlay?

export function MainHeader ({setCurrentMenuItem, currentMenuItem, menuItemOptions}) {
    const [showLogin, setShowLogin] = useState(false);
    const [showUnauthorize, setShowUnauthorize] = useState(false);
    const [toggleLoginRegister, setToggleLoginRegister] = useState(false);
    const [showMenu, setShowMenu] = useState(false);

    const menuLeft = useRef(null);

    const auth = useContext(AuthContext);

    // header={<Button type="button" icon="pi pi-chevron-right" onClick={(event) => setShowMenu(false)}></Button>}
    // visible={showMenu} position={'top-left'} modal={false}
    //                         onHide={() => setShowMenu(false)} draggable={false} resizable={false}
    function showLoginDialog() {
        setShowLogin(true);
    }

    function showUnauthorizeDialog() {
        setShowUnauthorize(true);
    }

    function handleLogin(response) {
        if (auth.login(response)){
            setToggleLoginRegister(false);
            setShowLogin(false);
            return true;
        } else {
            return false;
        }
    }

    function handleLogout(){
        console.log("trying to logout")
        auth.logout()
        setShowLogin(true);
    }

    const items = menuItemOptions.map((item,i) => (
        {label: item.displayname,
            command: () => {
            setCurrentMenuItem(item)},
            key: item.id,
        }));

    const ambuttonTemplate = () => {

        if(auth.isAMauthorized){
            return(<Button icon="pi pi-apple" text onClick={showUnauthorizeDialog}/>)
        } else {
            return("")
        }
    }

    const loginButtonTemplate = () => {
        if(auth.isAuthenticated()){
            return(<React.Fragment>
                {ambuttonTemplate()}
                <Button icon="pi pi-user" label={auth.currentUser.username} className="" aria-label="User" onClick={showLoginDialog}/>
            </React.Fragment>)
        } else {
            return(<React.Fragment>
                {ambuttonTemplate()}
                <Button icon="pi pi-user" className="p-button-rounded" aria-label="User" onClick={showLoginDialog}/>
            </React.Fragment>)
        }

    }

    // TabView alternative
    //    <div className="card" hidden={!showMenu}>
    //         {menuItemOptions.map((menuItem, i) =>
    //             <Button label={menuItem.displayname} disabled={!menuItem.public && !auth?.isAuthenticated}
    //                     tooltip={(!menuItem.public && !auth?.isAuthenticated) ? "Login required" : ""}
    //                     text onClick={() => setCurrentMenuItem(menuItem)}/>)}
    //     </div>
//             <div hidden={!showMenu} style={{backgroundColor: '#beaae0'}}>
//                 <TabMenu model={items} />
//             </div>

    return (
        <div>
            <Dialog header={toggleLoginRegister? "User Registration" : "Login" } visible={showLogin} position={'top-right'} modal={false}

                    onHide={() => setShowLogin(false)} draggable={false} resizable={false}>

                { auth?.isAuthenticated() ?
                    <div>
                        <h1>Welcome {auth.currentUser.username}!</h1><Button label="Logout" onClick={handleLogout}/><
                    /div>
                    :
                    <div>
                        <div className={"mb-5 mt-1"} hidden={toggleLoginRegister}><Login onLogin={handleLogin} /></div>
                        <div className={"mb-5 mt-1"} hidden={!toggleLoginRegister} ><Registration onRegistration={handleLogin}/></div>

                        <Button label={toggleLoginRegister? "Switch to Login" : "Register new user" } text  onClick={() => setToggleLoginRegister(!toggleLoginRegister)} />
                    </div>
                }
            </Dialog>

            <Dialog header={"Apple Music Connection"} visible={showUnauthorize} position={'top-right'} modal={false}

                    onHide={() => setShowUnauthorize(false)} draggable={false} resizable={false}>

                { auth?.isAMauthorized ?
                    <div>
                        <p>You are currently connected to Apple Music</p><Button label="Disconnect Apple Music" onClick={auth.logoutAM}/><
                    /div>
                    :
                    <div>
                        <p>You are currently not connected to Apple Music</p>
                    </div>
                }
            </Dialog>

            <Menu model={items} popup ref={menuLeft} id="popup_menu_left" style={{width:'270px'}}/>

            <Toolbar className="flex flex-wrap gap-4 pt-2 align-items-center body-background-color"
                     start={<React.Fragment><Button type="button" icon="pi pi-bars" onClick={(event) => menuLeft.current.toggle(event)} aria-controls="popup_menu_left" aria-haspopup></Button>
                     </React.Fragment>}
                     center={<React.Fragment><div style={{fontSize: "1.25em", fontWeight: 500}}>{currentMenuItem.displayname}</div></React.Fragment>}
                     end={loginButtonTemplate}
            ></Toolbar>


            {/*<div className="card" hidden={!showMenu}>*/}
            {/*    {menuItemOptions.map((menuItem, i) =>*/}
            {/*        <div key={menuItem.id}><Button  label={menuItem.displayname} disabled={!menuItem.public && !auth?.isAuthenticated()}*/}
            {/*                     text onClick={() => setCurrentMenuItem(menuItem)}/></div>)}*/}
            {/*</div>*/}
        </div>

    );
}